import React from 'react';

const Mensaje = ()=>(
    <p>Agrega las notas y sus respectivas ponderaciones para que podamos calcular tu nota final</p>
);

export default Mensaje;